import React, { useEffect, useState } from 'react';
import { useInView } from '../hooks/useInView';

const parseValue = (value) => {
  const match = String(value).match(/^(\d+)(.*)$/);
  if (!match) return { number: 0, suffix: value };
  return { number: parseInt(match[1], 10), suffix: match[2] };
};

const CountUp = ({ value, duration = 2000, className = '' }) => {
  const [ref, isInView] = useInView({ threshold: 0.5 });
  const { number, suffix } = parseValue(value);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return;

    const startTime = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * number));
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }, [isInView, number, duration]);

  return (
    <span ref={ref} className={className}>
      {count}{suffix}
    </span>
  );
};

export default CountUp;
